import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import PageTabHeader from "@/App/Layouts/PageBody/PageTabHeader";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import ViewContentBlockHeader from "@/App/Layouts/ViewContentBlockHeader";
import { ViewLayout } from "@/App/Layouts/ViewLayout";
import AppTypography from "@/common/components/Text/AppTypography";
import { ViewVariant } from "@/common/ts/layout";
import { CustomerDto } from "@/core/api/generated/v1";

import CustomerExternalUserLinkList from "../../CustomerExternalUserLinkList";

interface Props {
  customer: CustomerDto;
}

export default function ExternalUserLinksTabContent({ customer }: Props) {
  return (
    <PageTabContent>
      <ViewLayout
        displayProps={{ viewVariant: ViewVariant.Tab }}
        header={<PageTabHeader title={"Active"} />}
      >
        <ViewContentBlock>
          <CustomerExternalUserLinkList customer={customer} links={customer.externalUserLinks} />
        </ViewContentBlock>

        <ViewContentBlock>
          <Stack spacing={2}>
            <ViewContentBlockHeader>
              <AppTypography
                component='span'
                isInheritFontStyle
                decoration={{ variant: "helpText" }}
                tooltipProps={{ title: "Approx. last 10 records." }}
              >
                History
              </AppTypography>
            </ViewContentBlockHeader>

            <CustomerExternalUserLinkList
              customer={customer}
              links={customer.externalUserLinkHistory}
            />
          </Stack>
        </ViewContentBlock>
      </ViewLayout>
    </PageTabContent>
  );
}
